import Vue from 'vue'
import { Component, } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import * as types from '@survey/store/types'
import * as accountTypes from '@account/store/types'
import { SurveyStatisticsExamples, SurveyDetailHeader, SurveyReadQuestion, SurveyReadExamples } from '@survey/components'
import api from '@survey/api'
import StatisticsModalView from '@survey/views/ModalViews/SurveyStatisticsDetailModalView.vue'
import { IEDate, invalidateUrl, uGetIsInDate, uGetDateFormat } from '@appbase/util'

@Component({
    components: {
        StatisticsModalView,
        SurveyStatisticsExamples,
        SurveyDetailHeader,
        SurveyReadQuestion,
        SurveyReadExamples
    },
    computed: {
        ...mapGetters({
            user: accountTypes.USER,
            current: accountTypes.CURRENT,
            surveyDetail: types.SURVEY_STATISTICS,
            menuPermission: types.SURVEY_MENU_PERMISSIONS,
        })
    }
})
export default class SurveyStatisticsView extends Vue {
    user!: account.User
    current!: account.TCurrent
    surveyDetail!: survey.SurveyDetailResponse
    menuPermission!: survey.MenuPermissions

    questions: Array<survey.SurveyStatisticsItem> = []
    participantCount: number = 0

    isPopup: boolean = false
    isSurveyAdmin: boolean = false;
    isSurveyOwner: boolean = false;
    statisticsPerm: boolean = false;

    showModal: boolean = false
    modalData: {
        question: survey.SurveyStatisticsItem
        answers: survey.PersonSurvyAnswers[]
    } | null = null;   

    async created() {     
        this.isPopup = this.$route.path.toLowerCase().includes('popup')        
        this.setPage({
            title: this.$t('설문조사_결과').toString()
        })   

        this.statisticsPerm = this.checkPermission(this.surveyDetail.surveyDetailInfo);

        if (!this.statisticsPerm) {        
            await (window as any).alertAsync(this.$t('잘못된_접근입니다').toString())
            this.goBack()           
        } else {              
            this.init();
        }        
    }
    
    checkPermission(detail: survey.SurveyDetailItem | null): boolean {
        if(detail == null)
            return false;

        this.isSurveyAdmin = this.current.permissions.isSuperAdmin || this.current.permissions.isSurveyManager;
        this.isSurveyOwner = this.user.personCode === this.surveyDetail.surveyDetailInfo.createdId;

        if (detail.status >= 2) {
            if (this.isSurveyOwner || this.isSurveyAdmin) {
                return true;
            } else {
                const Start: Date = IEDate(uGetDateFormat('yyyy-MM-DD', IEDate(detail.resultStartDate)));
                const End: Date = IEDate(detail.resultEndDate);
                let inDate: boolean = uGetIsInDate(new Date(), Start, End);

                if (detail.isPublic && inDate) {
                    return true;
                } else {
                    return false;
                }
            }
        } else {
            return false;
        }
    }

    init() {
        let surveyId: number | null = this.surveyDetail.surveyDetailInfo.surveyId ?? null;

        if(surveyId) {
            api.survey.getSurveyStatisticsLists(surveyId).then(res => {
                this.questions = res.surveyStatisticsLists;
            });
        }
    }

    setTitle(idx: number, question: survey.SurveyStatisticsItem) {
        let typeString: string = '';
        switch(question.questionType) {
            case 0: 
                typeString = this.$t('선택형').toString();
                break;
            case 1: 
                typeString = this.$t('선택형_복수선택').toString();
                break;
            case 2: 
                typeString = this.$t('서술형').toString();
                break;
            case 3: 
                typeString = this.$t('단답형').toString();
                break;
            default:                 
        }

        return `${idx + 1}. ${typeString} ${question.questionText} `
    }

    goBack() {
        if (this.isPopup) {
            window.close()
        } else {
            this.$router.push({
                name: "SurveyList",
                query: {
                    MENUID: this.$route.query.MENUID
                }
            })
        }
    }

    poopupDetail(question: survey.SurveyStatisticsItem) {      
        api.survey.getSurveyStatisticsDetailLists(question.questionId).then(result => {
            this.modalData = {
                question: question,
                answers: result.personAnswers
            }

            this.showModal = true;
        })
    }

    closeModal() {
        this.modalData = null;
        this.showModal = false
    }

    onExportExcel() {
        var ifrmExcel = this.$refs.refExcelFrame as HTMLIFrameElement;

        if (ifrmExcel) {
            ifrmExcel.src = invalidateUrl(`/cm/Survey/Compose/api/exportToExcel?surveyId=${this.surveyDetail.surveyDetailInfo.surveyId}`)
        }
    }
}
